<template>
  <div v-if="data">
    <UiModal v-model="isFormModalOpen" render-content-on-mount width="1118px">
      <SoftwareCategoryTryDemoForm :data="data" />
    </UiModal>

    <InfoModal v-if="data.successResponse" v-model="isInfoModalOpen">
      <template v-if="data.successResponse.title" #title>
        <div v-html="data.successResponse.title" />
      </template>

      <template v-if="data.successResponse.text" #body>
        <div v-html="data.successResponse.text" />
      </template>

      <template v-if="data.successResponse.button" #footer>
        <UiButton size="md" @click="closeInfoModal">
          <span v-html="data.successResponse.button" />
        </UiButton>
      </template>
    </InfoModal>
  </div>
</template>

<script setup lang="ts">
import SoftwareCategoryTryDemoForm from '~/components/sections/categorySection/SoftwareCategoryTryDemoForm.vue';
import { useModalDialog } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isOpen: isFormModalOpen } = useModalDialog(props.data.id);
const { isOpen: isInfoModalOpen, close: closeInfoModal } = useModalDialog(
  `${props.data.id}-info`,
);
</script>
